var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 820,
    height: 712,
    viewBox: "0 0 820 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2088_29280)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.681 153.698C491.208 149.96 522.735 149.544 553.017 151.621C640.546 157.437 714.386 87.6496 714.386 0L1037.95 0V1028.12C958.721 1028.12 880.733 1050.55 816.019 1096.24C731.809 1155.23 629.346 1190.12 519.001 1190.12C214.516 1190.12 -29.8184 925.929 2.95315 614.378C28.2578 370.538 216.59 181.115 459.681 153.698ZM324.861 695.381C336.061 782.615 406.168 852.818 493.282 864.034C621.049 880.235 728.905 772.23 712.727 644.287C701.526 557.053 631.42 486.85 544.306 475.634C416.538 459.433 308.682 567.438 324.861 695.381Z",
    fill: "#FF6699"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.411 35.2844C184.182 13.8418 -20.1749 215.837 1.83275 457.921C18.4957 643.756 169.72 793.233 357.728 809.703C602.957 831.146 807.314 629.151 785.306 387.067C768.643 201.231 617.419 51.7548 429.411 35.2844ZM540.392 441.45C531.903 506.71 478.771 559.229 412.748 567.62C315.914 579.74 234.171 498.941 246.432 403.227C254.921 337.967 308.054 285.448 374.077 277.057C470.911 264.938 552.968 345.736 540.392 441.45Z",
    fill: "#F3FF00",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2088_29280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 712,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern02);
export default __webpack_public_path__ + "static/media/pattern02.7ce2de0ce8c703217ea128dec02a38b1.svg";
export { ForwardRef as ReactComponent };